import { render, staticRenderFns } from "./restart.vue?vue&type=template&id=579b0a96&scoped=true&"
import script from "./restart.vue?vue&type=script&lang=js&"
export * from "./restart.vue?vue&type=script&lang=js&"
import style0 from "./restart.vue?vue&type=style&index=0&id=579b0a96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579b0a96",
  null
  
)

export default component.exports